import { mergeStyleSets } from "@fluentui/react";
import { CONTAINER_WIDTH, BREAKPOINT, CONTAINER_WIDTH_VERTICAL, COMPONENT_LABEL_MARGIN_RIGHT, COMPONENT_LABEL_WIDTH, COMPONENT_WIDTH_VERTICAL, COMPONENT_WIDTH, COMPONENT_LABEL_WIDTH_VERTICAL, } from "./Constants.styles";
export const labelContainerStyle = mergeStyleSets({
    container: {
        [`@media (max-width: ${BREAKPOINT}px)`]: {
            display: "flex",
            marginBottom: "1em",
            width: `${COMPONENT_LABEL_WIDTH_VERTICAL}`,
            maxWidth: `${COMPONENT_LABEL_WIDTH_VERTICAL}`,
        },
    },
});
export const labelStyle = {
    width: `${COMPONENT_LABEL_WIDTH}`,
    whiteSpace: "pre-line",
    marginRight: `${COMPONENT_LABEL_MARGIN_RIGHT}`,
    fontSize: "inherit !important",
    fontWeight: "semibold",
    [`@media (max-width: ${BREAKPOINT}px)`]: {
        width: `${COMPONENT_LABEL_WIDTH_VERTICAL}`,
        minWidth: `${COMPONENT_LABEL_WIDTH_VERTICAL}`,
        maxWidth: `${COMPONENT_LABEL_WIDTH_VERTICAL}`,
    },
};
export const containerStyle = {
    display: "flex",
    justifyContent: "left",
    alignItem: "center",
    minWidth: `${CONTAINER_WIDTH}`,
    maxWidth: `${CONTAINER_WIDTH}`,
    [`@media (max-width: ${BREAKPOINT}px)`]: {
        width: `${CONTAINER_WIDTH_VERTICAL}`,
        minWidth: `${CONTAINER_WIDTH_VERTICAL}`,
        maxWidth: `${CONTAINER_WIDTH_VERTICAL}`,
    },
};
export const descriptionTextStyle = {
    minWidth: `${COMPONENT_WIDTH}`,
    maxWidth: `${COMPONENT_WIDTH}`,
    display: "block",
    paddingTop: ".5rem",
    paddingBottom: "1rem",
    fontSize: ".758rem",
    wordBreak: "spaces",
    "& i": {
        paddingTop: ".1rem",
        paddingRight: ".2rem",
    },
    [`@media (max-width: ${BREAKPOINT}px)`]: {
        width: `${COMPONENT_WIDTH_VERTICAL}`,
        minWidth: `${COMPONENT_WIDTH_VERTICAL}`,
        maxWidth: `${COMPONENT_WIDTH_VERTICAL}`,
    },
};
export const visuallyHiddenStyle = mergeStyleSets({
    srOnly: {
        position: "absolute",
        top: "0",
        left: "0",
        width: "1px",
        height: "1px",
        padding: "0",
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        clipPath: "inset(50%)",
        whiteSpace: "nowrap",
        border: "0",
    },
});
